import { DAY_MS } from 'constants/time-and-date';
import { shiftDateObjectByTimezone } from 'tz-offsets';
import { localDate, parseIso8601Date } from 'helpers/time';

export function getDates(timezone) {
  const now = shiftDateObjectByTimezone(new Date(), timezone);
  const month = now.getMonth();
  const year = now.getFullYear();
  const nextYear = month < 11 ? year : year + 1;
  const nextMonth = month < 11 ? month + 1 : 0;

  return {
    TODAY: localDate(now),
    THIRTY_DAYS: localDate(new Date(now.valueOf() + DAY_MS * 29)),
    CURRENT_MONTH: localDate(new Date(year, month, 1, 12, 0, 0)),
    NEXT_MONTH: localDate(new Date(nextYear, nextMonth, 1, 12, 0, 0)),
  };
}

export function canSelectNextDay(timezone, selectedDate) {
  const { THIRTY_DAYS } = getDates(timezone);
  const dateSelectionLimit = parseIso8601Date(THIRTY_DAYS);
  const date = typeof selectedDate === 'string' ? parseIso8601Date(selectedDate) : selectedDate;
  return date < dateSelectionLimit;
}
